import { render } from "./Dashboard2.html?vue&type=template&id=493d171d&scoped=true&ts=true"
import script from "./Dashboard2.ts?vue&type=script&lang=ts"
export * from "./Dashboard2.ts?vue&type=script&lang=ts"

import "./Dashboard2.scss?vue&type=style&index=0&id=493d171d&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493d171d"]])

export default __exports__